export default "__VITE_ASSET__BBV43npc__"